import { PropsWithChildren, memo, useEffect } from 'react'
import { useAppSelector } from 'redux/store'
import { ThemeVariant } from 'types/theme.type'
import { getSystemTheme } from 'utils/get-system-theme'

interface ThemeProviderProps {}
export const ThemeProvider: React.FC<PropsWithChildren<ThemeProviderProps>> = memo(({ children }) => {
    const { theme } = useAppSelector(state => state.theme)

    useEffect(() => {
        const mutatedTheme = theme === ThemeVariant.SYSTEM ? getSystemTheme() : theme
        if (document.body.classList.contains(ThemeVariant.DARK)) {
            document.body.classList.remove(ThemeVariant.DARK)
        }
        if (mutatedTheme === ThemeVariant.DARK) {
            document.body.classList.add(ThemeVariant.DARK)
        }
    }, [theme])

    return children
})
ThemeProvider.displayName = 'ThemeProvider'
